// eslint-disable-next-line import/no-unresolved
const slickSlider = require('./slider');
const constants = require('../constants');
const preferences = require('../preferences');
const utils = require('../utils');

const initHomeSlick = () => {
    const { prev, next } = utils.getSliderLabels();
    const homeSliders = $('.home-top');

    if (homeSliders.length) {
        homeSliders.each((index, slider) => {
            const $slider = $(slider).parents('.banner-carousel-inner');
            const sliderID = `#${$slider.attr('id')} .home-top`;
            const sliderAutoplay = $slider.attr('data-autoplay') && $slider.attr('data-autoplay') !== undefined && $slider.attr('data-autoplay') !== 'false';
            const sliderAutoplaySpeed = $slider.attr('data-autoplay-speed');
            const sliderMode = $slider.attr('data-mode') && $slider.attr('data-mode') !== undefined && $slider.attr('data-mode') !== 'slide';
            const sliderAutoplayValue = $slider.attr('data-autoplay') && $slider.attr('data-autoplay') !== undefined ? sliderAutoplay : preferences.slider.autoplay;
            const sliderAutoplaySpeedValue = sliderAutoplaySpeed && sliderAutoplaySpeed !== undefined ? sliderAutoplaySpeed : preferences.slider.autoplaySpeed;
            const sliderModeValue = $slider.attr('data-mode') && $slider.attr('data-mode') !== undefined ? sliderMode : preferences.slider.fade;
            const sliderAdaptiveHeight = $slider.attr('data-height-fixed') && $slider.attr('data-height-fixed') !== undefined ? $slider.attr('data-height-fixed') : 'false';

            // check if init has video
            $slider.on('init', (event, slick, currentSlide) => {
                if (slick.$slides.find('video').length) {
                    slick.options.autoplaySpeed = slick.$slides.find('video')[0].duration * 1000;
                }
            });
            // Add the afterChange event handler
            $slider.on('afterChange', (event, slick, currentSlide) => {
                if ($(slick.$slides[currentSlide]).find('video').length) {
                    slick.options.autoplaySpeed = $(slick.$slides[currentSlide]).find('video')[0].duration * 1000;
                } else {
                    slick.options.autoplaySpeed = sliderAutoplaySpeedValue;
                }
            });

            slickSlider.methods.useCustomizableSlick(
                sliderID,
                false,
                '',
                '',
                preferences.slider.slidesToShow,
                {
                    infinite: preferences.slider.infinite,
                    arrows: true,
                    useTransform: false,
                    autoplay: sliderAutoplayValue,
                    autoplaySpeed: sliderAutoplaySpeedValue,
                    fade: sliderModeValue,
                    easing: 'swing',
                    vertical: preferences.slider.vertical,
                    rows: preferences.slider.rows,
                    adaptiveHeight: sliderAdaptiveHeight,
                    prevArrow: `<button type="button" class="icon-left-arrow-line no-btn" aria-label="${prev}"></button>`,
					nextArrow: `<button type="button" class="icon-right-arrow-line no-btn" aria-label="${next}"></button>`,
                    responsive: [
                        {
                            breakpoint: constants.viewport_bootstrap.sm,
                            settings: {
                                arrows: false,
                                dots: true,
                            },
                        },
                    ],
                },
            );
        });
    }
};

module.exports = {
    initHomeSlick,
};
